module.exports = __webpack_public_path__ + "img/本体3.bb9c2258.gif";